





























































































	import { Component, Vue } from "vue-property-decorator";
	import API from "@/api";
	import { EventBus } from "@/main";
	import { mapState } from "vuex";
	/* Nuevas Importaciones */
	import ShowLoading from "@/components/panel/ShowLoading.vue";
	import Step1 from "@/views/scoring/steps/Step1.vue";
	import Step2 from "@/views/scoring/steps/Step2.vue";
	import Step3 from "@/views/scoring/steps/Step3.vue";
	import Step4 from "@/views/scoring/steps/Step4.vue";
	import Step5 from "@/views/scoring/steps/Step5.vue";

	@Component({
		computed: {
			...mapState(["user"]),
		},
		async beforeMount() {
			await fetch('https://api.ipify.org?format=json')
				.then(x => x.json())
				.then(({ ip }) => {
					this.$data.ip=ip;
					if(this.$route.params.angloToScoring){
						// @ts-ignore
						API.stateBusiness(this.$route.params.form22.rut.split('.').join(''))
							.then((res:any)=>{
								// Step
								this.$data.steps = parseInt(this.$route.params.etapa);
								// StepView
								this.$data.stepsView = parseInt(this.$route.params.stepView);
								// idEmpresa
								// Data desde Scoring
								this.$data.dataDesdeAnglo = {
									form22 : this.$route.params.form22,
									stateBusiness: res,
								}
							}).finally(()=>{
								this.$data.loaded = true;
							})
					}else{
						if(this.$route.params.retomarPanelScoring){
							// Estado del negocio
							API.stateBusiness(this.$route.params.rutempresa.split('.').join(''))
								.then((resState:any)=>{
									// @ts-ignore
									API.requestsByCompanyId(this.$route.params.idempresa)
										.then((resCredito: any) => {
											API.empresadueno(this.$route.params.idempresa)
												.then((res: any)=>{
													this.$data.steps = parseInt(this.$route.params.etapa);
													this.$data.loaded = true;
													setTimeout(()=>{
														if(res.data.data != null){
															this.$data.dueniosEmpresa = res.data.data
														}
														this.$data.empresa = this.$route.params.idempresa;
														this.$data.empresaNombre = this.$route.params.nombreempresa;
														this.$data.rutEmpresa = this.$route.params.dni;
														let resCreditoScoring = resCredito.creditos.find((element : any) => element.garantia == null);
														resCreditoScoring.imagenes = resState.data.data.imagenes;
														this.$data.dataCredito = resCreditoScoring;
													})
												}).catch((err: any)=>{})
											API.registraranalytics('Scoring', this.$data.ip, `paso ${this.$route.params.etapa}`, this.$store.state.user.id, this.$route.params.idempresa, 'retomado' )
												.then((res: any) => {})
												.catch((err: any) => {});
										})
										})
						}else{
							if(this.$route.params.myoperationToScoring){
								this.$data.steps = parseInt(this.$route.params.etapa);
								this.$data.stepsView = parseInt(this.$route.params.stepView);
								this.$data.loaded = true;
								setTimeout(()=>{
									this.$data.rutEmpresaStep2 = this.$route.params.rutempresa;
								
								})
								
							}else{
								if (this.$route.params.etapa != null && this.$route.params.idempresa != null){
									// datos capturados desde el panel Mis Operaciones
									// @ts-ignore
									API.requestsByCompanyId(this.$route.params.idempresa)
										.then((resCredito: any) => {
											// Se recibe el Id, Nombre, Rut y Step
											API.empresadueno(this.$route.params.idempresa)
												.then((res: any)=>{
													this.$data.steps = parseInt(this.$route.params.etapa);
													this.$data.loaded = true;
													setTimeout(()=>{
														if(res.data.data != null){
															this.$data.dueniosEmpresa = res.data.data
														}
														this.$data.empresa = this.$route.params.idempresa;
														this.$data.empresaNombre = this.$route.params.nombreempresa;
														this.$data.rutEmpresa = this.$route.params.dni;
														let resCreditoScoring = resCredito.creditos.find((element : any) => element.garantia == null);
														this.$data.dataCredito = resCreditoScoring;
													})
												}).catch((err: any)=>{})
											API.registraranalytics('Scoring', this.$data.ip, `paso ${this.$route.params.etapa}`, this.$store.state.user.id, this.$route.params.idempresa, 'retomado' )
												.then((res: any) => {})
												.catch((err: any) => {});
										})
								}else if(this.$route.params.rutempresa){
									this.$data.steps = parseInt(this.$route.params.etapa);
									this.$data.loaded = true;
									setTimeout(()=>{
										this.$data.rutEmpresaStep2 = this.$route.params.rutempresa;
									})
									API.registraranalytics('Scoring' , this.$data.ip, 'Inicio', this.$store.state.user.id)
										.then((res: any) => {})
										.catch((err: any) => {});
								}else{
									this.$data.loaded = true;
								}
							}
						}
					}
				});
		},
		data() {
			return {
				loaded: false,
				steps: 1,
				stepsView: 0,
				empresa: null,
				empresaNombre: null,
				rutEmpresa: null,
				rutEmpresaStep2: null,
				dueniosEmpresa: [],
				ip: null,
				actualizarEmpresa: null,
				dataCredito: null,
				dataDesdeAnglo: null
			};
		},
		beforeRouteEnter  (to, from, next) {
			next(vm => {
				if (vm.$store.state.user.via_id == 2){
					vm.$router.push('/angloamerican')
				}
			});
		},
		methods: {
			/* Nuevos Metodos */
			volverInicio(){ // Vuelve al panel inicial
				this.$router.push('/panel-facto/estadisticas');
			},
			siguientePasoEvaluacion(nextStep){ // Recibe nextStep como el siguiente paso en el flujo
				this.$data.steps = nextStep;
				window.scrollTo(0,0); // Manda la vista al principio
			},
			capturaDataEmpresa(empresa){ // Recibe la data de la empresa desde el paso 2 para poder setearlas en todos los pasos posteriores como props.
				this.$data.empresa = empresa.id;
				this.$data.empresaNombre = empresa.empresa;
				this.$data.rutEmpresa = empresa.rut;
				this.$data.dueniosEmpresa = empresa.dueniosEmpresa.length > 0 ? empresa.dueniosEmpresa : [];
			},
			continuarMasTarde(value){ // Recibe un obj. con el idEmpresa y Step para setearlo en el tracking
				API.registraranalytics('Scoring', this.$data.ip, `Paso ${value.step}`, this.$store.state.user.id, value.idEmpresa)
					.then((res: any) => {
						// Retornamos al panel del solicitante
						this.$router.push({
							path: "/panel-facto/estadisticas"
						})
					})
					.catch((err: any) => {});
			},
			empresaPaso2(data){
				//console.log('RECIBE DATA PARA ACTUALZIAR EMRPESA ', data);
				this.$data.actualizarEmpresa = data;
			},
		},
  		components: {
			ShowLoading,
			Step1,
			Step2,
			Step3,
			Step4,
			Step5
		}
	})
	export default class ScoringV2 extends Vue {}
